import { createContext } from 'react';

// Define the shape of the authentication context
export interface AuthContextType {
  isAuthenticated: boolean;
  accessToken: string | null;
  refreshToken: string | null;
  login: (username: string, password: string) => Promise<{ success: boolean; error?: string }>;
  logout: () => void;
  getAccessToken: () => string | null;
  refreshAccessToken: () => Promise<boolean>;
}

// Create the authentication context with default values
export const AuthContext = createContext<AuthContextType>({
  isAuthenticated: false,
  accessToken: null,
  refreshToken: null,
  login: async () => ({ success: false, error: 'Not implemented' }),
  logout: () => {},
  getAccessToken: () => null,
  refreshAccessToken: async () => false,
});
